import Activities from "./Activities";
import CreateAssessment from "./CreateAssessment";
import GuideTool from "./GuideTool";

const Dashboard = () => {
  return (
    <div className="dashboard-container h-full w-full p-4 row">
      {/* Guide Tool and Create Assessment in one row */}
      <div className="col-12 sm:col-7 lg:col-8 h-[35%]  p-4 cursor-pointer">
        <GuideTool />
      </div>
      <div className="col-12 sm:col-5 lg:col-4 h-[35%]  p-4 cursor-pointer">
        <CreateAssessment />
      </div>

      {/* Activities component */}
      <div className="col-12  h-[65%] p-4">
        <Activities />
      </div>
    </div>
  );
};

export default Dashboard;
